import { defineFilterSpec, multiField, rangeField, text } from '@/lib/api/filter-spec';

import type { CustomerFilterFormValues, CustomerListFilters } from './types';

/** Single declaration of the customer list filters, shared by api/drawer/page/export.
 *  Multi-select statuses join to a comma string on the wire (the real query param is `status`,
 *  singular, per `GetCustomersDto` — the FE keeps the plural `statuses` internally since every
 *  drawer/page reference already uses it); Device Range maps to `deviceCountFrom`/`deviceCountTo`.
 *  `search` participates only in the query params. */
const spec = defineFilterSpec<CustomerListFilters, CustomerFilterFormValues>([
  text('search'),
  multiField('statuses', 'status'),
  rangeField('deviceCount'),
]);

export const toListQuery = spec.toListQuery;
export const toDefaults = spec.toDefaults;
export const toFilters = spec.toFilters;
export const hasActiveFilters = spec.hasActiveFilters;
